
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component<ProfileDetailsBaseComponent>({})
export default class ProfileDetailsBaseComponent extends Vue {
  @Prop({ default: '' })
  title!: string;
}
